// extracted by mini-css-extract-plugin
export default {"edit":"KmKwTs2IYWj4H1cpJ2_s","delete":"yTnkjIG37lWV5j_pDlSW"};